import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { onChangeClassifiedParkingsWeekdaysFilter } from '../../../ac/onChangeMapFilters';
import { ClassifiedParkingDayweekFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const ClassifiedParkingsWeekdayFiltersComponent = ({
    onChangeClassifiedParkingsWeekdaysFilter,
    classifiedParkingsWeekdaysStatuses,
}) => (
    <div>
        <div className={styles.legHead}>{t`Период`}:</div>
        <StandardRadioGroup
            value={classifiedParkingsWeekdaysStatuses}
            onChange={onChangeClassifiedParkingsWeekdaysFilter}
        >
            {ClassifiedParkingDayweekFilterValues.map(({ label, value }) => (
                <FormControlLabel
                    key={value}
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={classifiedParkingsWeekdaysStatuses === value}
                            onChange={onChangeClassifiedParkingsWeekdaysFilter}
                            value={value}
                            className={classnames(
                                styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: classifiedParkingsWeekdaysStatuses === value,
                                }
                            )}
                            size='small'
                        />
                    }
                    label={i18n._(label)}
                    labelPlacement='end'
                />
            ))}
        </StandardRadioGroup>
        <div>
            <div className={styles.circlesbox}>
                <div className={styles.circleClassifiedParking_1}></div>
                <div className={styles.circleClassifiedParking_2}></div>
            </div>
            <div className={styles.classifiedParkingLegendContainer}>
                <div className={classnames(styles.legendListItem, styles.legendListItemLeft)}>{t`Средняя`}</div>
                <div className={classnames(styles.legendListItem, styles.legendListItemRight)}>{t`Топовая`}</div>
            </div>

            <div className={styles.classifiedParkingLegendContainer}>
                <div className={styles.listItemGeneric}>{t`Баланс`}</div>
                <div className={styles.listItemGeneric}>{t`Профицит`}</div>
                <div className={styles.listItemGeneric}>{t`Дефицит`}</div>
            </div>
            <div style={{ padding: '10px' }}>
                <small>{t`Цвет круга определяет тип парковки`}</small>
                <br></br>
                <small>{t`Размер круга определяет класс парковки`}</small>
            </div>
        </div>
        <br></br>
        <div style={{ padding: '10px' }}>
            <span className={styles.legendSubtitle}>{t`Классификация парковок по поездкам пользователей по будням и выходным за последние 14 дней`}</span>
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters: { classifiedParkingsWeekdaysStatuses } }) => ({ classifiedParkingsWeekdaysStatuses });
const ConnectedComponent = connect(mapStateToProps, { onChangeClassifiedParkingsWeekdaysFilter })(ClassifiedParkingsWeekdayFiltersComponent);
export const ClassifiedParkingsWeekdaysFilter = withDisplayedLayersCheck(ConnectedComponent, t`Классифицированные парковки`);
